module.exports = __webpack_public_path__ + "static/media/tangent2.259ea95d.jpg";